import { defineComponent } from 'navigation-components/platform/models';
import { getPortalId } from '../../common/utils';
import { NAV_ONBOARDING_TOURS_COMPONENT } from '../constants';
import { getOnboardingTourIdQueryParam } from './internal/getOnboardingTourIdQueryParam';
import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../constants/z_index';
import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
export const navOnboardingToursComponentDef = defineComponent(NAV_ONBOARDING_TOURS_COMPONENT, {
  name: NAV_ONBOARDING_TOURS_COMPONENT,
  path: `/nav-onboarding-tours/${getPortalId()}`,
  queryParams: getOnboardingTourIdQueryParam(),
  capabilities: [capabilities.RESTYLE_CAP.getName(), capabilities.REQUEST_ELEMENT_LOCATIONS_CAP.getName()],
  propsSchema: {
    tourId: args.optional(args.string())
  },
  initialProps: {
    tourId: undefined
  },
  functions: {
    updateTourSelectorRects: {
      args: {
        targetElements: args.arrayOf(args.object({
          targetElementSelector: args.string(),
          targetElementRect: args.optional(args.object({
            top: args.number(),
            left: args.number(),
            width: args.number(),
            height: args.number()
          }))
        }))
      }
    }
  },
  deferLoading: true,
  iframeProps: {
    style: {
      position: 'absolute',
      zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT,
      width: '0px',
      height: '0px'
    }
  }
});